import {
  SELECTED_REPORT_LOCATIONS,
  SELECTED_REPORT_ROOMS,
  SELECTED_REPORT_SCOPE_OF_WORK,
  REPORT_CREATED,
  REPORT_UPDATED,
  REPORT_CREATING,
  REPORT_UPDATING,
  PROJECT_REPORTS,
  REPORT_ERRORS,
  REPORT_DELETED,
  SELECTED_REPORT,
  REPORT_SHARED,
  REPORT_SHARING,
  CLEAR_REPORTS,
} from 'Containers/ReportsAndDocuments/Reports/actions';
import type { reportActionTypes } from 'Containers/ReportsAndDocuments/Reports/actions';
import { addOrRemoveFromArray } from 'Utils/helpers';

const initialState = {
  selectedReportLocations: [],
  selectedReportRooms: [],
  selectedReportScopeOfWork: [],
  reportCreating: false,
  reportUpdating: false,
  reportCreated: false,
  reportUpdated: false,
  reportDeleted: false,
  reportSharing: false,
  reportShared: false,
  reports: undefined,
  errors: undefined,
  selectedReport: {},
};

export const reportsReducer = (state = initialState, action: reportActionTypes) => {
  const { type, payload } = action;

  switch (type) {
    case SELECTED_REPORT_LOCATIONS:
      return {
        ...state,
        selectedReportLocations: addOrRemoveFromArray(state.selectedReportLocations, payload),
      };
    case SELECTED_REPORT_ROOMS:
      return {
        ...state,
        selectedReportRooms: addOrRemoveFromArray(state.selectedReportRooms, payload),
      };
    case SELECTED_REPORT_SCOPE_OF_WORK:
      return {
        ...state,
        selectedReportScopeOfWork: addOrRemoveFromArray(state.selectedReportScopeOfWork, payload),
      };
    case REPORT_CREATING:
      return {
        ...state,
        reportCreating: payload,
      };
    case REPORT_UPDATING:
      return {
        ...state,
        reportUpdating: payload,
      };
    case REPORT_CREATED:
      return {
        ...state,
        reportCreated: payload,
      };
    case REPORT_UPDATED:
      return {
        ...state,
        reportUpdated: payload,
      };
    case SELECTED_REPORT:
      return {
        ...state,
        selectedReport: payload,
      };
    case REPORT_DELETED:
      return {
        ...state,
        reportDeleted: payload,
      };
    case REPORT_SHARED:
      return {
        ...state,
        reportShared: payload,
      };
    case REPORT_SHARING:
      return {
        ...state,
        reportSharing: payload,
      };
    case PROJECT_REPORTS: {
      if (payload.data) {
        payload.data.map((report) => {
          if (report.settings.includes('rocketdry')) {
            report.type = 'Drying Log';
          } else if (report.settings.includes('compact')) {
            report.type = 'Photo - Compact';
          } else if (report.settings.includes('expanded')) {
            report.type = 'Photo - Expanded';
          } else if (report.settings.includes('custom_report')) {
            report.type = 'Custom';
          } else {
            report.type = 'Photo - Large';
          }
          return report;
        });
      }
      return {
        ...state,
        reports: payload,
      };
    }
    case CLEAR_REPORTS:
      return {
        ...state,
        reports: undefined,
      };
    case REPORT_ERRORS:
      return {
        ...state,
        errors: payload,
      };

    default:
      return state;
  }
};
